export enum Tabs {
  PartnerAgencies = "Partner Agencies",
  SearchRecruitmentAgencies = "Search Recruitment Agencies",
}
